import { useState, useEffect } from 'react';

export default function FixedMenu() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-teal-500 shadow-lg z-40">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <p className="text-center text-sm text-gray-700 mb-3 hidden md:block">
          コインランドリー経営のことなら、お気軽にご相談ください!
        </p>
        <div className="flex gap-3 justify-center">
          <a 
            href="tel:08025278110"
            className="flex items-center justify-center gap-2 bg-blue-500 text-white px-6 py-3 rounded font-bold whitespace-nowrap text-sm md:text-base no-underline"
            style={{ textDecoration: 'none' }}
          >
            <i className="ri-phone-fill text-white"></i>
            <span>080-2527-8110</span>
          </a>
          <a 
            href="https://www.laundrysite.jp/contact.html" 
            className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded font-bold transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base"
          >
            <i className="ri-mail-fill text-white"></i>
            <span>お問い合わせフォームはこちら</span>
          </a>
        </div>
      </div>
    </div>
  );
}
